<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ROvSjp/html/docimages/cover_ader.jpg?1684305978769" alt="This image is the cover for the book The Greatest Commandment"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Greatest Commandment
      </h1>
      <p class="bookDescription body article font2">
        <p>The Messiah said the Sh'ma was the greatest commandment. This book explains why.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Irene Lipson
      </h2>
      
      <p class="authorDescription body article">After a life of active preaching and teaching among her people, she now writes, gardens and spends time with her eleven grandchildren.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Messianic Jewish Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ba0a0116